import { getIcons } from "./getIcons";
import { useMemo } from "react";
import Box from "@mui/material/Box";
import Icon from "./Icon";
import { IconButton } from "@mui/material";
const IconList = ({ direction = "row" }: { direction?: string }) => {
  const icons = useMemo(() => getIcons(), []);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: direction,
      }}>
      {icons.map(({ name, props, url }) => (
        <Box key={name}>
          <IconButton href={url}>
            <Icon name={name} props={props} />
          </IconButton>
        </Box>
      ))}
    </Box>
  );
};
export default IconList;
